import React, { memo } from 'react';

interface ColorSwatchProps {
  color: string; // Hex color format (#RRGGBB)
  onChange: (color: string) => void;
  className?: string;
  title?: string;
}

/**
 * Color swatch component for color customization
 * Optimized with memo to prevent unnecessary re-renders
 * Only handles hex color format for performance
 */
const ColorSwatch: React.FC<ColorSwatchProps> = memo(({
  color,
  onChange,
  className = '',
  title = 'Change color',
}) => {
  // Ensure color is in hex format (fallback to default if invalid)
  const hexColor = color && color.startsWith('#') ? color : '#3B82F6';

  return (
    <div className={`relative ${className}`}>
      <input
        type="color"
        value={hexColor}
        onChange={(e) => onChange(e.target.value)}
        className="w-5 h-5 rounded border border-gray-300 cursor-pointer"
        title={title}
      />
    </div>
  );
});

ColorSwatch.displayName = 'ColorSwatch';

export default ColorSwatch;

